import { useIsFetching, useQueryClient } from '@tanstack/react-query';
import { IconLoader2 } from '@tabler/icons-react';
import { LoadingDots } from '../LoadingDots';

export function GlobalLoader() {
    const queryClient = useQueryClient();
    const isFetching = useIsFetching();

    if (!isFetching) return null;

    const fetchingQueries = queryClient
        .getQueryCache()
        .findAll({ fetchStatus: 'fetching' })
        .filter((q) => q.state.data === undefined && q.meta?.title !== undefined);

    if (!fetchingQueries.length) return null;

    return (
        <div
            className="card shadow"
            style={{
                position: 'fixed',
                bottom: '1rem',
                right: '1rem',
                zIndex: 1050,
                width: '280px',
                pointerEvents: 'none',
            }}
        >
            <div className="card-body p-2">
                <div className="d-flex flex-column gap-1">
                    {fetchingQueries.map((query) => (
                        <div key={query.queryHash} className="d-flex align-items-center gap-2 text-secondary small">
                            <IconLoader2 size={16} className="text-muted" style={{ animation: 'spin 1s linear infinite', flexShrink: 0 }} />
                            <span>
                                {query.meta!.title as string}
                                <LoadingDots />
                            </span>
                        </div>
                    ))}
                </div>
            </div>

            <style>{`
                @keyframes spin {
                    from { transform: rotate(0deg); }
                    to { transform: rotate(360deg); }
                }
            `}</style>
        </div>
    );
}
